var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloud(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 27,
    fill: "black",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5332 25.1884C15.116 25.545 13.8779 26.4068 13.0514 27.6119C12.2248 28.817 11.8668 30.2825 12.0445 31.7329C12.2223 33.1834 12.9236 34.519 14.0166 35.4889C15.1097 36.4588 16.5193 36.9961 17.9806 37H34.4625C35.5204 36.9993 36.5662 36.7745 37.5309 36.3405C38.4957 35.9065 39.3576 35.2731 40.06 34.482C40.7623 33.6908 41.2891 32.7599 41.6058 31.7505C41.9224 30.7411 42.0217 29.6761 41.897 28.6256C41.7724 27.5751 41.4267 26.5628 40.8827 25.6555C40.3386 24.7482 39.6086 23.9665 38.7407 23.3616C37.8727 22.7568 36.8865 22.3426 35.847 22.1464C34.8074 21.9502 33.7381 21.9764 32.7094 22.2232L30.7166 22.7656",
    stroke: "#111111",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7106 22.2232C32.1985 20.1953 30.9344 18.438 29.1747 17.3075C27.4149 16.177 25.2911 15.7579 23.2339 16.1352C21.1766 16.5125 19.3398 17.658 18.0957 19.3394C16.8517 21.0208 16.2935 23.1123 16.5343 25.1899C16.5343 25.1899 16.7636 26.5115 17.2326 27.2607",
    stroke: "#111111",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.e08e8efbc581fefdc7f8a6176e664734.svg";
export { ForwardRef as ReactComponent };